import { ArrowRightIcon } from '@ag1/ui';
import { toPlainText } from '@portabletext/react';
import { buttonClickEvent } from 'analytics/events/studio';
import clsx from 'clsx';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import type { Header, HeaderFullV2 } from 'types/studio/studio';

import { usePageContext } from 'processes/Page/PageContext';
import { useMemo } from 'react';

import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import HeaderMenuLink from '../Navigation/LinkElement/LinkElement';
import styles from './MarketingLinks.module.scss';

type MarketingLinksProps = {
  sticky: boolean;
  marketingButton: Header['marketingButton'];
} & Pick<HeaderFullV2, 'theme' | 'desktopLayout' | 'mobileLayout'>;

const MarketingLinks = ({
  marketingButton,
  sticky,
  desktopLayout,
  mobileLayout,
  theme
}: MarketingLinksProps) => {
  const { disablePrimaryCTAButtons, shouldDisableCTALink, maybeReplaceOfferlessCheckoutLink } =
    usePageContext();

  const link = useMemo(() => {
    let result = marketingButton.marketingLink;
    if (shouldDisableCTALink(result)) {
      result = '';
    }
    return maybeReplaceOfferlessCheckoutLink(result) || '';
  }, [marketingButton.marketingLink, maybeReplaceOfferlessCheckoutLink, shouldDisableCTALink]);

  return (
    <>
      <HeaderMenuLink
        href={link}
        delinkOnEmpty={disablePrimaryCTAButtons}
        className={clsx(
          styles.marketingLink,
          sticky && styles.sticky,
          desktopLayout === 'transparentWhite' && styles.whiteDesktop,
          mobileLayout === 'transparentWhite' && styles.whiteMobile,
          getThemeCSSClass(theme)
        )}
        data-gtm-skip-global
        onClick={() =>
          buttonClickEvent({
            location: 'header',
            clickText: toPlainText(marketingButton.topButton),
            url: marketingButton.marketingLink
          })
        }>
        <CustomPortableText value={marketingButton.topButton} />
      </HeaderMenuLink>

      <HeaderMenuLink
        href={link}
        delinkOnEmpty={disablePrimaryCTAButtons}
        className={clsx(
          styles.marketingStickyLink,
          sticky && styles.sticky,
          getThemeCSSClass(theme),
          disablePrimaryCTAButtons && styles.disabled
        )}
        data-gtm-skip-global
        onClick={() =>
          buttonClickEvent({
            location: 'header',
            clickText: toPlainText(marketingButton.stickyButton),
            url: marketingButton.marketingLink
          })
        }>
        <CustomPortableText value={marketingButton.stickyButton} />
        <ArrowRightIcon className={styles.arrowIcon} />
      </HeaderMenuLink>
    </>
  );
};

export default MarketingLinks;
